import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DndModule } from 'ngx-drag-drop';

import { BriefingComponent } from './components/Briefing/briefing.component';
import { PageBuilderModule } from '../../Common/PageBuilder/page-builder.module';
import { BriefingsApi } from '../../api/briefings/briefings.api';
import { BriefingsService } from './services/briefings.service';
import { ProgressBarModule } from 'primeng/progressbar';

import { LocalizationModule } from '../../Core/Localization/localization.module';

import { DynamicMentionListBlockComponent } from './components/DynamicMentionListBlock/dynamic-mention-list-block.component';
import { SortToolComponent } from './components/SortTool/sort-tool.component';
import { SortToolRightSidebarComponent } from './components/SortToolRightSidebar/sort-tool-right-sidebar.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { BriefingSendNowHelper } from './helpers/briefing-send-now.helper';
import { AutomaticCoverageDialogComponent } from './components/AutomaticCoverageDialog/automatic-coverage-dialog.component';
import { CuratedMentionListBlockComponent } from './components/CuratedMentionListBlock/curated-mention-list-block.component';
import { BriefingDateFieldComponent } from './components/BriefingDateField/briefing-date-field.component';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { MonitorSharedModule } from '../Shared/monitoring-shared.module';
import { BriefingGlobalCustomizationComponent } from './components/BriefingGlobalCustomization/briefing-global-customization.component';
import { TagsModule } from '../../Common/Tags/tags.module';
import { SortToolBlockComponent } from './components/SortToolBlock/sort-tool-block.component';
import { FilterModule } from '../../Common/Filter/filter.module';
import { CuratedFiltersFieldComponent } from './components/CuratedFiltersField/curated-filters-field.component';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { BriefingPreviewDialogComponent } from './components/BriefingPreviewDialog/briefing-preview-dialog.component';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { StylesModule } from '../../Common/Styles/styles.module';
import { NewBriefingComponent } from './components/NewBriefing/new-briefing.component';
import { BriefingSaveTemplateDialogComponent } from './components/BriefingSaveTemplateDialog/briefing-save-template-dialog.component';
import { CanvasSaveTemplateDialogComponent } from './components/CanvasSaveTemplateDialog/canvas-save-template-dialog.component';
import { MailingListsModule } from '../../Common/MailingLists/mailing-lists.module';
import { ContentLibraryDialogModule  } from '../../Common/ContentLibrary/content-library.module';
import { TableOfContentSettingsComponent } from './components/TableOfContentSettings/table-of-content-settings.component';
import { TableOfContentBlockComponent } from './components/TableOfContentBlock/table-of-content-block.component';
import { TableOfContentStyleFieldComponent } from './components/TableOfContentStyleField/table-of-content-style-field.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DatePickerModule } from 'primeng/datepicker';
import { ColorPickerModule } from 'primeng/colorpicker';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { ImportWarningDialogComponent } from './components/ImportWarningDialog/import-warning-dialog.component';
import { UsersModule } from '../../Core/Users/users.module';
import { MentionsModule } from '../../Common/Mentions/mentions.module';
import { BriefingSortByFieldComponent } from './components/BriefingSortByField/briefing-sort-by-field.component';
import { BriefingReportComponent } from './components/BriefingReport/briefing.report.component';
import { TargetingSharedModule } from '../../Common/TargetingShared/targeting-shared.module';
import { EmailRecipientCardComponent } from './components/BriefingReport/RecipientSearch/EmailRecipientCard/email-recipient-card.component';
import { EmailRecipientToolbarComponent } from './components/BriefingReport/RecipientSearch/EmailRecipientToolbar/email-recipient-toolbar.component';
import { EmailRecipientSearchTabComponent } from './components/BriefingReport/RecipientSearch/email-recipient-search-tab.component';
import { TakeOverModule } from '../../Common/TakeOver/take-over.module';
import { DeduplicateConfirmationDialogComponent } from './components/DeduplicateConfirmationDialog/deduplicate-confirmation-dialog.component';
import { ManuallyAddCoverageDialogComponent } from './components/ManuallyAddCoverageDialog/manually-add-coverage-dialog.component';
import { BriefingsStepsNavigationComponent } from './components/BriefingStepsNavigation/briefing-steps-navigation.component';
import { BriefingPublishingStepComponent } from './components/BriefingPublishingStep/briefing-publishing-step.component';
import { BriefingReviewStepComponent } from './components/BriefingReviewStep/briefing-review-step.component';
import { CuratedAdditionalSettingsFieldComponent } from './components/CuratedAdditionalSettingsField/curated-additional-settings-field.component';
import { CuratedAutoInsightDialogComponent } from './components/CuratedAutoInsightDialog/curated-auto-insight-dialog.component';
import { AutomaticAdditionalSettingsFieldComponent } from './components/AutomaticAdditionalSettingsField/automatic-additional-settings-field.component';
import { CuratedAutoWebsocketDialogComponent } from './components/CuratedAutoWebsocketDialog/curated-auto-websocket-dialog.component';
import { BriefingsAutoGenService } from './services/briefings-auto-gen.service';
import { BriefingComposeTabComponent } from './components/BriefingComposeTab/briefing-compose-tab.component';
import { BriefingCanvasTemplateSetupComponent } from './components/BriefingCanvasTemplateSetup/briefing-canvas-template-setup.component';
import { BriefingCanvasCustomizeComponent } from './components/BriefingCanvasCustomize/briefing-canvas-customize.component';
import { AnalysisFieldComponent } from './components/AnalysisField/analysis-field.component';
import { GenerateAnalysisDialogComponent } from './components/GenerateAnalysisDialog/generate-analysis-dialog.component';
import { AnalysisUpsellPopupComponent } from './components/AnalysisUpsellPopup/analysis-upsell-popup.component';
import { CoverageInsightsFieldsComponent } from './components/CoverageInsightsForm/coverage-insights-form.component';
import { GeneratingAnalysisDialogComponent } from './components/GeneratingAnalysisDialog/generating-analysis-dialog.component';
import { BriefingCoverageAnalysisService } from './services/briefing-coverage-analysis.service';
import { NewOnlineBriefingComponent } from './components/NewOnlineBriefing/new-online-briefing.component';
import { ReportsModule } from '../../Common/Reports/reports.module';
import { BriefingSeriesService } from './services/briefing-series.service';
import { BriefingChartBlockComponent } from './components/BriefingChartBlock/briefing-chart-block.component';
import { ChartsModule } from '@Common/Charts/charts.module';
import { ReportsSeriesService } from '@Common/Reports/services/reports-series.service';
import { BriefingChartComponent } from './components/BriefingChart/briefing-chart.component';
import { CuratedSortByFieldComponent } from './components/CuratedSortByField/curated-sort-by-field.component';
import { BriefingImageBlockComponent } from './components/BriefingImageBlock/briefing-image-block.component';
import { BriefingsTemplateFactorService } from './services/briefings-template-factory.service';
import { CuratorAnalysisButtonFieldComponent } from './components/CuratorAnalysisButtonField/curator-analysis-button-field.component';
import { BriefingGeneratingPdfDialogComponent } from './components/BriefingGeneratingPdfDialog/briefing-generating-pdf-dialog.component';
import { ShareCanvasDialogComponent } from './components/BriefingReport/RecipientSearch/ShareCanvasDialog/share-canvas-dialog.component';
import { CuratedInfoSectionComponent } from './components/CuratedInfoSection/curated-info-section.component';
import { BriefingNaturalLanguagePopupComponent } from './components/BriefingNaturalLanguagePopup/briefing-natural-language-popup.component';
import {
    BriefingNaturalLanguageLoadingDialogComponent
} from './components/BriefingNaturalLanguageLoadingDialog/briefing-natural-language-loading-dialog.component';
import { CoverageImageDialogComponent } from './components/CoverageImageDialog/coverage-image-dialog.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DigestApiService } from '@api/digest/digest.api.service';
import { DigestService } from '@Monitor/Shared/services/digest.service';
import { DigestSubscriberApiService } from '@api/digest/digest-subscriber.api.service';
import { Am5BriefingChartComponent } from './components/Am5BriefingChart/am5-briefing-chart.component';
import { CoverageAnalysisService } from '@Monitor/Shared/services/coverage-analysis.service';
import { CanvasEmailStyleComponent } from './components/CanvasEmailStyle/canvas-email-style.component';
import { EmailPreviewDialogComponent } from './components/EmailPreviewDialog/email-preview-dialog.component';
import { PrecisionClipSetupTakeoverComponent } from './components/PrecisionClipSetupTakeover/precision-clip-setup-takeover.component';
import { PrecisionConfirmDialogComponent } from './components/PrecisionConfirmDialog/precision-confirm-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DatePickerModule,
        SelectModule,
        ColorPickerModule,
        TooltipModule,
        PageBuilderModule,
        LocalizationModule,
        AutoCompleteModule,
        CommonFormsModule,
        CommonDialogsModule,
        ClickOutsideModule,
        MiscModule,
        MonitorSharedModule,
        TagsModule,
        StylesModule,
        FilterModule,
        LayoutModule,
        DndModule,
        CoreDialogsModule,
        CommonBasicModule,
        MailingListsModule,
        UsersModule,
        MentionsModule,
        TargetingSharedModule,
        TakeOverModule,
        ContentLibraryDialogModule,
        ReportsModule,
        ChartsModule,
        ProgressBarModule,
        ScrollingModule
    ],
    declarations: [
        BriefingComponent,
        DynamicMentionListBlockComponent,
        SortToolComponent,
        SortToolRightSidebarComponent,
        SortToolBlockComponent,
        AutomaticCoverageDialogComponent,
        CuratedMentionListBlockComponent,
        BriefingDateFieldComponent,
        BriefingGlobalCustomizationComponent,
        CuratedFiltersFieldComponent,
        BriefingSortByFieldComponent,
        BriefingPreviewDialogComponent,
        NewBriefingComponent,
        BriefingSaveTemplateDialogComponent,
        CanvasSaveTemplateDialogComponent,
        TableOfContentSettingsComponent,
        TableOfContentBlockComponent,
        TableOfContentStyleFieldComponent,
        ImportWarningDialogComponent,
        BriefingReportComponent,
        EmailRecipientCardComponent,
        EmailRecipientToolbarComponent,
        EmailRecipientSearchTabComponent,
        ShareCanvasDialogComponent,
        DeduplicateConfirmationDialogComponent,
        ManuallyAddCoverageDialogComponent,
        BriefingsStepsNavigationComponent,
        BriefingPublishingStepComponent,
        BriefingReviewStepComponent,
        CuratedAdditionalSettingsFieldComponent,
        CuratedAutoInsightDialogComponent,
        CuratedAutoWebsocketDialogComponent,
        AutomaticAdditionalSettingsFieldComponent,
        BriefingComposeTabComponent,
        BriefingCanvasTemplateSetupComponent,
        BriefingCanvasCustomizeComponent,
        AnalysisFieldComponent,
        GenerateAnalysisDialogComponent,
        AnalysisUpsellPopupComponent,
        CoverageInsightsFieldsComponent,
        GeneratingAnalysisDialogComponent,
        NewOnlineBriefingComponent,
        BriefingChartBlockComponent,
        BriefingChartComponent,
        CuratedSortByFieldComponent,
        BriefingImageBlockComponent,
        CuratorAnalysisButtonFieldComponent,
        BriefingGeneratingPdfDialogComponent,
        CuratedInfoSectionComponent,
        BriefingNaturalLanguagePopupComponent,
        BriefingNaturalLanguageLoadingDialogComponent,
        CoverageImageDialogComponent,
        Am5BriefingChartComponent,
        CanvasEmailStyleComponent,
        EmailPreviewDialogComponent,
        PrecisionClipSetupTakeoverComponent,
        PrecisionConfirmDialogComponent
    ],
    exports: [
        DynamicMentionListBlockComponent,
        SortToolComponent,
        SortToolRightSidebarComponent,
        SortToolBlockComponent,
        AutomaticCoverageDialogComponent,
        CuratedMentionListBlockComponent,
        BriefingDateFieldComponent,
        BriefingGlobalCustomizationComponent,
        CuratedFiltersFieldComponent,
        BriefingSortByFieldComponent,
        BriefingPreviewDialogComponent,
        TableOfContentSettingsComponent,
        TableOfContentBlockComponent,
        TableOfContentStyleFieldComponent,
        ImportWarningDialogComponent,
        ManuallyAddCoverageDialogComponent,
        CuratedAdditionalSettingsFieldComponent,
        CuratedAutoInsightDialogComponent,
        CuratedAutoWebsocketDialogComponent,
        AutomaticAdditionalSettingsFieldComponent,
        CuratorAnalysisButtonFieldComponent,
        BriefingGeneratingPdfDialogComponent,
        ShareCanvasDialogComponent,
        BriefingNaturalLanguagePopupComponent,
        BriefingNaturalLanguageLoadingDialogComponent
    ],
    providers: [
        BriefingsApi,
        BriefingsService,
        {
            provide: 'BriefingsService',
            useExisting: BriefingsService
        },
        BriefingSendNowHelper,
        BriefingDateFieldComponent,
        BriefingsAutoGenService,
        BriefingCoverageAnalysisService,
        {
            provide: CoverageAnalysisService,
            useExisting: BriefingCoverageAnalysisService
        },
        ReportsSeriesService,
        BriefingSeriesService,
        BriefingsTemplateFactorService,
        DigestService,
        DigestApiService,
        DigestSubscriberApiService
    ]
})
export class BriefingsModule { }
